import React from 'react';
import { Button } from 'antd';

const BRAND = '#1D2C7B';

/**
 * Primary toolbar action. Keeps the label on `sm` and up and collapses to the
 * icon alone on phones, where toolbar space is scarce.
 */
export default function ActionButton({ icon, children, collapseOnMobile = true, className = '', ...rest }) {
    return (
        <Button
            type="primary"
            className={`!h-9 !px-3.5 sm:!px-5 !rounded-lg !text-sm !font-semibold !inline-flex !items-center !gap-1.5 ${className}`}
            style={{ backgroundColor: BRAND, borderColor: BRAND }}
            {...rest}
        >
            {icon}
            {children && (
                <span className={collapseOnMobile ? 'hidden sm:inline' : undefined}>{children}</span>
            )}
        </Button>
    );
}

/** Borderless icon button used inside table rows. */
export function RowIconButton({ className = '', ...rest }) {
    return (
        <button
            type="button"
            className={`inline-flex p-1.5 rounded-md text-slate-400 hover:text-[#1D2C7B] hover:bg-slate-100 transition-colors ${className}`}
            {...rest}
        />
    );
}
